import { consultar } from 'helpers/api';

const controller = "contratos-assinaturas";

export const ContratosAssinaturasService = {
   nova,
   download,
   visualizar,
   assinar,
   recusar,
};

async function nova(contratoId) {
   return await consultar(`/${controller}/novaAssinatura/${contratoId}.json`, 'put');
}

async function download(contratoId, token) {
   return await consultar(`/${controller}/downloadContrato/${contratoId}/${token}.json`, 'get');
}

// Consulta os dados do contrato/assinatura para a tela pública de assinatura (sem login)
async function visualizar(contratoId, assinaturaId, token) {
   return await consultar(`/${controller}/assinarContrato.json`, 'put', {
      contrato_id: contratoId,
      assinatura_id: assinaturaId,
      token: token,
      acao: 'visualizacao',
   });
}

// Registra o aceite da assinatura do contrato
async function assinar(contratoId, assinaturaId, token, dados) {
   return await consultar(`/${controller}/assinarContrato.json`, 'put', {
      contrato_id: contratoId,
      assinatura_id: assinaturaId,
      token: token,
      acao: 'assinatura',
      ...dados,
   });
}

// Registra a recusa da assinatura do contrato
async function recusar(contratoId, assinaturaId, token) {
   return await consultar(`/${controller}/assinarContrato.json`, 'put', {
      contrato_id: contratoId,
      assinatura_id: assinaturaId,
      token: token,
      acao: 'recusa',
   });
}

// Gerado pelo gerador de SERVICES @felipeshow (20:41:17 18/01/2022)